import {meServices} from '../../services';
import {baseApi} from '../queryApiCreator';
import {TreeSettingsModel} from '../../../models/treeModelInnstillingWrapper';
import {AdmEnhet, ColumnSettings} from '../../../models';
import {IdentitetBilde} from '../../../models/identitetBilde';
import {admEnhetQueryApiService} from './admEnhetQueryApiService';
import {DbConnectionInfo} from '../../../models/DBConnectionInfo';

const TABLE_SETT_FETCH_TAG = 'table_fetch';
const TABLE_SETT_SET_TAG_ = 'table_sett';
const TREE_SETT_TAG = 'treesetting';
const IS_LOCAL_BRUKER_ADMINISTRATOR = 'isLocalBrukerAdministrator';
const IS_LOCAL_TEKSTMAL_ADMINISTRATOR = 'isLocalTekstmalAdministrator';


export const meQueryApiService = baseApi
  .enhanceEndpoints({
    addTagTypes: [TREE_SETT_TAG, TABLE_SETT_SET_TAG_,TABLE_SETT_FETCH_TAG, IS_LOCAL_BRUKER_ADMINISTRATOR, IS_LOCAL_TEKSTMAL_ADMINISTRATOR],
  })
  .injectEndpoints({
    endpoints: build => {
      return {
        hentTreesetting: build.query<TreeSettingsModel, string>({
          query: (id: string) => ({ request: meServices.hentTreesetting(id) }),
          providesTags: (result, error, arg) => [
            { type: TREE_SETT_TAG, id: arg },
          ],
        }),
        hentIdentitetBilde: build.query<IdentitetBilde, void>({
          query: () => {return ({ request: meServices.hentIdentitetBilde() });}
        }), 
        setTreesetting: build.mutation< TreeSettingsModel, TreeSettingsModel & {id: string}>({
          query: (arg ) => ({
            request: meServices.setTreesetting(arg.id, arg),
          }),
          invalidatesTags: (resp, err, arg) => [{ type: TREE_SETT_TAG, id: arg.id }],
        }),
        hentTableSettings: build.query<ColumnSettings, string>({
          query: (id: string) => ({ request:  meServices.hentTableSettings(id) }),
          providesTags: (result, error, arg) => [
            { type: TABLE_SETT_SET_TAG_, id: arg  },
          ],
        }),
        setTableSettings: build.mutation<ColumnSettings, {columns: ColumnSettings, id: string}>({
          query: (arg ) => ({
            request: meServices.setTableSettings(arg.id, arg.columns),
          }),
          invalidatesTags: (resp, err, arg) => [{ type: TABLE_SETT_SET_TAG_, id: arg.id}]
        }),
        isLocalBrukerAdministrator: build.query<boolean, void>({
          query: () => ({ request: meServices.isLocalBrukerAdministrator() }),
          providesTags: () => [IS_LOCAL_BRUKER_ADMINISTRATOR]
        }),
        hentLokalBrukerAdminAvdelinger: build.query<AdmEnhet[], void>({
          query: () => ({ request: meServices.lokalBrukerAdminAvdelinger() }),
          providesTags: () => [{type: admEnhetQueryApiService.serviceName, id: 'LIST'}]
        }),
        isLocalTekstmalAdministrator: build.query<boolean, void>({
          query: () => ({ request: meServices.isLocalTekstmalAdministrator() }),
          providesTags: () => [IS_LOCAL_BRUKER_ADMINISTRATOR]
        }),
        hentLokalTekstmalAdminAvdelinger: build.query<AdmEnhet[], void>({
          query: () => ({ request: meServices.lokalTekstmalAdminAvdelinger() }),
          providesTags: () => [{type: admEnhetQueryApiService.serviceName, id: 'LIST'}]
        }),
        varsleWebsakPluss: build.mutation<string, void>({
          query: () => ({ request: meServices.varsleWebsakPluss() }),
        }),
        dbConnection: build.query<DbConnectionInfo, void>({
          query: () => ({ request: meServices.dbconnectionInfo() }),
        }),
      };
    },
  });
